module.exports = __webpack_public_path__ + "img/img_78.8e90c9d7.png";